import { TablePaginationOptions } from '../tables/tables.types';

export interface Part {
  id: number;
  part_type: string;
  color: string;
  serial_no: string;
  modele: string;
  processeur: string;
  taille: string;
  annee_debut: string;
  annee_fin: string;
  year: string;
  compatibility_id: number;
  serial_device: string;
  text_content: string;
  grade_id: number;
  grade: string;
  assembled_parts: string;
  created_at: string;
  updated_at: string;
  device_id: number;
}

export interface PartsList {
  count: number;
  values: Part[];
}

export enum PartType {
  screen = 'Écran',
  tile = 'Dalle',
  case = 'Coque',
  motherboard = 'Carte Mère',
  topcase = 'Chassis',
  'motherboard+topcase' = 'Carte Mère + Chassis',
  'screen+topcase' = 'Écran + Chassis'
}

export interface PartsListOptions {
  filters?: Partial<Record<keyof Part, string[]>>;
  pagination?: TablePaginationOptions;
}

export enum DestructedStatus {
  NOT_DESTRUCTED = 'not_destructed',
  DESTRUCTED = 'destructed'
}
